import styled from '@emotion/styled';
import { createUUID } from '@shared/constants/Keys';
import { roleIcons } from '@shared/constants/organization/RoleValues';
import OrganizationMemberRole, {
    OrganizationMemberRoleKeys,
} from '@shared/models/organizations/OrganizationMemberRole';
import { useTranslation } from 'react-i18next';
import MemberDetailItem from '../member/MemberDetailItem';

// TODO: Double check if these rendering of all role options is really borken or just storybook issue with re-renddering

interface IRoleIconListProps {
    role: OrganizationMemberRole;
    variant?: 'stack' | 'listOnly';
}

export default function RoleIconList({ role, variant = 'stack' }: Readonly<IRoleIconListProps>) {
    const { t } = useTranslation();
    const randomUUID = createUUID();

    const renderMemberDetailItems = (keys: string[], activeKeys: string[]) =>
        keys.map((key) => {
            const typedKey = key as OrganizationMemberRoleKeys;
            return (
                <MemberDetailItem
                    chip={true}
                    active={role[typedKey]}
                    variant="small"
                    key={randomUUID + typedKey}
                    title={t(`common:organization.${typedKey}.title`)}
                />
            );
        });

    if (!role) return null;
    return (
        <>
            <IconWrapper>{renderMemberDetailItems(Object.keys(roleIcons), Object.keys(role))}</IconWrapper>
        </>
    );
}

const IconWrapper = styled.div`
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
`;
